import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { useAbortedEffect } from "../../../components/hooks";
import { KnowledgeAPI } from "../../../axios/api";

import { Button } from "primereact/button";

export default function ModulePopKnowledgeDetail({
  prePopOption,
  closePrePop,
  setPreReload,
}) {
  const dispatch = useDispatch();
  const [apiData, setApiData] = useState({});

  useAbortedEffect(
    (signal) => {
      dispatch(setProgress(true));

      let params = {
        id: prePopOption.data.id,
      };

      KnowledgeAPI.getKnowledgesDetails({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, total, message } = result;

        if (Response === 1) {
          setApiData(data);
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [prePopOption]
  );

  return (
    <>
      <div className="px-3">
        <h2 className="text-center mb-4">{apiData.title}</h2>

        {apiData.url_type === 1 && (
          <iframe
            className="w-full h-25rem md:h-35rem mb-4"
            src={apiData.url}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        )}

        {apiData.url_type === 3 && (
          <a className="inline-block text-lg mb-3" href={apiData.url}>
            {apiData.url}
          </a>
        )}

        <div className="text-lg line-height-4">{apiData.content}</div>

        {apiData.url_type === 2 && (
          <iframe
            className="w-full h-40rem md:h-50rem mt-3 mb-4"
            src={apiData.url}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
          ></iframe>
        )}

        <div className="text-center mt-4">
          <Button
            className="p-button-secondary p-button-sm px-3"
            type="button"
            label="關閉"
            onClick={() => {
              if (prePopOption.data.is_read === 0)
                setPreReload((state) => ({ ...state, list: true }));
              closePrePop({ type: prePopOption.type });
            }}
          />
        </div>
      </div>
    </>
  );
}
